<template>
  <div
    class="app_card"
    :aria-label="$t(`monolith.apps.${appId}.name`)"
  >
    <router-link
      :to="appRoute"
      :class="[$q.screen.xs && 'row']"
    >
      <div class="col-6 app_card__pict column justify-center">
        <q-img :src="appImg" />
      </div>
      <div class="col-6 app_card__text">
        <div class="title">
          {{ $t(`monolith.apps.${appId}.name`) }}
        </div>
        <p v-if="$te(`monolith.apps.${appId}.description`)">
          {{ $t(`monolith.apps.${appId}.description`) }}
        </p>
      </div>
    </router-link>
  </div>
</template>
<script>
import { useCurUser } from '@/composables/useCurUser'

export default {
  name: 'AppCard',
  props: {
    appId: {
      type: String,
      required: true,
    },
    appUrl: {
      type: String,
      default: null,
    },
  },
  setup() {
    return {
      curUser: useCurUser(),
    }
  },
  computed: {
    appImg() {
      return new URL(`/src/assets/img/apps/${this.appId}.jpg`, import.meta.url).href
    },
    appRoute() {
      if (this.appId === 'cat') {
        return {
          name: 'catalog',
          query: { ...this.$route.query },
        }
      }
      if (this.appId === 'ers') {
        return {
          name: 'ers.request',
          query: { ...this.$route.query },
        }
      } else if (this.appId === 'oepc') {
        return {
          name: 'oepc.request',
          params: { action: 'welcome' },
          query: { ...this.$route.query },
        }
      } else {
        return {
          name: 'valuation.request',
          query: {
            ...this.$route.query,
            valuation_type: this.curUser.submitableValuations.value[0],
          },
          params: { action: 'start' },
        }
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.app_card {
  background: $base;
  border-radius: 5px;
  border: 1px solid;
  overflow: hidden;
  transition: all 0.2s ease-out;
  border-color: $border;
  box-shadow: 0 2px 14px 0 rgba(0, 47, 80, 0);
  height: 100%;

  &:hover {
    cursor: pointer;
    border-color: var(--q-primary);
    box-shadow: 0 2px 14px 0 rgba(0, 47, 80, 0.1);
  }

  &__text {
    padding: 24px;

    .title {
      color: var(--q-dark);
      font-weight: 500;
    }

    p {
      margin-top: 8px;
      color: var(--q-secondary);
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px;
    }
  }

  &__pict {
    background-color: var(--light);
  }
}
</style>
